import React, { createContext, useContext, useState } from 'react';
import { ReferenceData } from '../@types/Templates';
import { HeaderOption } from '../components/TemplateEnitity/TemplateEntity';

const fieldOptions: HeaderOption[] = [];
const firstDataLine: string[] = [];
const referenceData: ReferenceData = { fields: {}, rows: {}, entityType: '' };
export const TemplateEntityContext = createContext({
  referenceData,
  fieldOptions,
  setFieldOptions: (state: HeaderOption[]) => {},
  firstDataLine,
  setFirstDataLine: (state: string[]) => {}
});

interface TemplateEntityContextProviderProps {
  referenceData: ReferenceData;
  children: React.ReactNode;
}

export const TemplateEntityContextProvider = ({ referenceData, children }: TemplateEntityContextProviderProps) => {
  const [fieldOptions, setFieldOptions] = useState<HeaderOption[]>([]);
  const [firstDataLine, setFirstDataLine] = useState<string[]>([]);
  return (
    <TemplateEntityContext.Provider
      value={{ referenceData, fieldOptions, setFieldOptions, firstDataLine, setFirstDataLine }}
    >
      {children}
    </TemplateEntityContext.Provider>
  );
};

export const useTemplateEntityContext = () => useContext(TemplateEntityContext);
